/**
 * ExpressionTypeEnum
 * An enumeration.
 */
export enum ExpressionTypeEnum {
  User = 'user',
  Group = 'group',
}